import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, RevealWordsOnScroll } from "./Reveal";

// Reusable conversion band placed between sections.
export default function CTASection({
  overline = "Begin Your Journey",
  heading = "Ready to reserve your date?",
  body,
  actions = [
    { to: "/pricing", label: "Request Pricing", primary: true },
    { to: "/tour", label: "Schedule a Tour" },
  ],
  dark = true,
  testId = "cta-section",
}) {
  const base = dark ? "bg-navy text-ivory" : "bg-blush text-navy";
  return (
    <section data-testid={testId} className={`${base} relative overflow-hidden`}>
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32">
        <div className="grid gap-10 md:grid-cols-12 md:items-end">
          <div className="md:col-span-8">
            <Reveal>
              <span className={`overline ${dark ? "text-gold" : "text-gold"}`}>{overline}</span>
            </Reveal>
            <h2 className="mt-6 font-serif text-4xl md:text-6xl font-light leading-[1.05] tracking-tight">
              <RevealWordsOnScroll text={heading} />
            </h2>
            {body && (
              <Reveal delay={0.15}>
                <p className={`mt-6 max-w-xl text-base md:text-lg font-light leading-relaxed ${dark ? "text-ivory/70" : "text-navy/70"}`}>
                  {body}
                </p>
              </Reveal>
            )}
          </div>
          <div className="md:col-span-4 flex flex-wrap gap-4 md:justify-end">
            {actions.map((a, i) => (
              <Link
                key={a.to}
                to={a.to}
                data-testid={`${testId}-action-${i}`}
                className={
                  a.primary
                    ? "btn-gold group"
                    : `btn-outline group ${dark ? "text-ivory hover:bg-ivory hover:text-navy" : "text-navy hover:bg-navy hover:text-ivory"}`
                }
              >
                {a.label}
                <ArrowUpRight size={16} className="ml-2 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
